<template>
        <div class="card mb-5">
          <div class="card-header">
            <h2>{{ review.establishment.consultant.firstname }} effectue un signalement.</h2>
          </div>
          <div class="card-body">
            <h5>Voici le contenu du signalement en cours de rédaction par MHR</h5>
            <br>
            <textarea class="textarea" rows="10" disabled>{{ state.data ? state.data.text : "" }}</textarea>
          </div>
          <div class="card-body">
            <EstablishmentStateComments
              :comments="state && state.data ? state.data.comments : []"
              @comments:added="update_data"
            />
            <div class="message is-warning">
              <div class="message-body">
                Cet avis est en cours de signalement, vous recevrez bientôt une notification
                de la plateforme,<br>
                merci de nous faire suivre tous les emails concernant ce signalement
              </div>
            </div>
          </div>
        </div>
      </template>

      <script>
      import UPDATE_STATE_DATA from '@/gql/mutations/updateStateData.graphql';
      import { gqlMutation } from '@/gqlClient.js';
      import tools from "@/tools.js"
      import StateComments from "@/components/StateComments.vue"
      import EstablishmentStateComments from '@/components/EstablishmentStateComments'

      export default {
        name: "EstablishmentStateSignalingWriting",
        components: { StateComments, EstablishmentStateComments },
        props: {
          review: {
            type: Object
          }
        },
        data() {
          return {
            state: null
          }
        },
        methods: {
          async save_modification() {
            var serialized = JSON.stringify(this.state.data)
            serialized = tools.b64_encode(serialized)
            await gqlMutation(UPDATE_STATE_DATA, { uid: this.state.uid, serialized: serialized })
          },
          update_data(comments) {
            if (this.state && this.state.data) {
              this.state.data.comments = comments
              this.save_modification()
            }
          }
        },
        created() {
          var self = this
          self.state = self.review.current_state
          if (self.state && self.state.data) {
            if (typeof self.state.data === "string") {
              self.state.data = JSON.parse(self.state.data)
            }
          }
          if (self.$djangows && self.$djangows.onmodelsignals) {
            self.$djangows.onmodelsignals(
              { modelName: "state", appLabel: "state" },
              function(event) {
                if (event.obj) {
                  if (event.obj.uid === self.state.uid) {
                    if (event.signal_type === "post_save" && event.created === false) {
                      if (self.state && self.state.data && event.obj.data && event.obj.data.comments) {
                        self.state.data.comments = event.obj.data.comments
                      }
                    }
                  }
                }
              }
            )
          }
        }
      }
      </script>

      <style lang="scss" scoped>
      </style>